import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  SupplierDto,
  SupplierListDto,
  SupplierFilterDto,
  CreateSupplierRequest,
  UpdateSupplierRequest,
  SupplierStatementDto,
} from '@/types/supplier.types';

export const supplierApi = {
  /** GET /api/v1/suppliers — paginated list with optional search/filter */
  getList: (filter?: SupplierFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<SupplierListDto>>>('/suppliers', {
      params: filter,
    }),

  /** GET /api/v1/suppliers/{id} — full supplier record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<SupplierDto>>(`/suppliers/${id}`),

  /** GET /api/v1/suppliers/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<SupplierDto>>(
      `/suppliers/by-code/${encodeURIComponent(code)}`,
    ),

  /** POST /api/v1/suppliers — create a new supplier */
  create: (data: CreateSupplierRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/suppliers', data),

  /** PUT /api/v1/suppliers/{id} — update supplier details */
  update: (id: string, data: UpdateSupplierRequest) =>
    apiClient.put<ApiResponse<object>>(`/suppliers/${id}`, data),

  /** DELETE /api/v1/suppliers/{id} — soft-delete the supplier */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/suppliers/${id}`),

  /** GET /api/v1/suppliers/{id}/statement — chronological statement with running balance */
  getStatement: (
    id: string,
    params: { dateFrom?: string; dateTo?: string; currencyCode?: string },
  ) =>
    apiClient.get<ApiResponse<SupplierStatementDto>>(
      `/suppliers/${id}/statement`,
      { params },
    ),
};
